import { createSelector, createSlice } from '@reduxjs/toolkit';
import {
  getUserFeatureEnabled,
  saveUserFeatureEnabled,
} from '../../services/userFeatureToggleService';

export const initialState = {
  settings: {
    viewGrid: true,
  },
  loading: false,
  loaded: false,
  analysisFilterOption: 'analysis',
  connectedContentWarning: {
    hypotheses: {},
    analyses: {},
  },
};

const userSettingsSlice = createSlice({
  name: 'userSettings',
  initialState,
  reducers: {
    setUserSettings: (state, action) => {
      return {
        ...state,
        settings: { ...state.settings, ...action.payload },
        loading: false,
        loaded: true,
      };
    },
    setAnalysisFilterOption: (state, action) => {
      return {
        ...state,
        analysisFilterOption: action.payload,
      };
    },
    setUserSettingsIsLoading: (state, { payload = true }) => {
      return {
        ...state,
        loading: payload,
      };
    },
    toggleViewGrid: (state) => ({
      ...state,
      settings: { viewGrid: !state.settings.viewGrid },
    }),
    setConnectedContentWarning: (state, action) => {
      const { connectedContentWarning } = state;
      const existingWarningState = {
        ...connectedContentWarning,
      };
      const { contentType, projectId, setting } = action.payload;
      existingWarningState[contentType][projectId] = setting;
      state.connectedContentWarning = existingWarningState;
    },
  },
});

// Actions
export const {
  setUserSettings,
  setAnalysisFilterOption,
  setUserSettingsIsLoading,
  toggleViewGrid,
  setConnectedContentWarning,
} = userSettingsSlice.actions;

// Selectors
export const getUserSettingsSelector = (state) => state.userSettings;
export const getIsDarkModeSelector = (state) =>
  state?.userSettings?.settings?.darkMode;
export const getConnectedContentWarning = createSelector(
  getUserSettingsSelector,
  (slice) => slice.connectedContentWarning
);

// Thunk
export const fetchConnectedContentPreference =
  (projectId, contentType, featureName) => async (dispatch) => {
    try {
      const getPreferenceResponse = await getUserFeatureEnabled(
        projectId,
        featureName
      );
      if (!getPreferenceResponse) {
        throw Error(`failed to get user feature ${featureName}!`);
      }
      const { enabled } = getPreferenceResponse;
      dispatch(
        setConnectedContentWarning({
          projectId,
          contentType,
          setting: enabled,
        })
      );
    } catch (e) {
      // TODO: proper error handling
      // eslint-disable-next-line no-console
      console.log(e);
    }
  };

export const changeConnectedContentPreference =
  (projectId, contentType, featureName, setting) => async (dispatch) => {
    try {
      const setPreferenceResponse = await saveUserFeatureEnabled(
        projectId,
        featureName,
        setting
      );
      if (
        setPreferenceResponse === undefined ||
        setPreferenceResponse === null
      ) {
        throw Error(`failed to update user feature ${featureName}!`);
      }
      dispatch(
        fetchConnectedContentPreference(projectId, contentType, featureName)
      );
    } catch (e) {
      // TODO: proper error handling
      // eslint-disable-next-line no-console
      console.log(e);
    }
  };

export default userSettingsSlice.reducer;
